import { useEffect, useState } from "react";

let globalShowError;
let globalShowSuccess;

export function useGlobalErrorToast() {
  const [error, setError] = useState(null);

  useEffect(() => {
    globalShowError = setError;
    return () => {
      globalShowError = null;
    };
  }, []);

  const handleClose = () => setError(null);

  return error ? (
    <div style={{
      position: "fixed",
      top: 20,
      right: 20,
      background: "#d32f2f",
      color: "white",
      padding: "16px 24px",
      borderRadius: 8,
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      zIndex: 9999,
      fontWeight: "bold",
      minWidth: 240,
      maxWidth: 400,
      display: "flex",
      alignItems: "flex-start",
      gap: 12,
    }}>
      <span style={{ wordBreak: "break-word", flex: 1 }}>{error}</span>
      <button onClick={handleClose} style={{
        flexShrink: 0,
        alignSelf: "flex-start",
        background: "transparent",
        color: "white",
        border: "none",
        fontSize: 18,
        cursor: "pointer",
        lineHeight: 1,
        padding: 0,
      }}>×</button>
    </div>
  ) : null;
}

export function useGlobalSuccessToast() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    globalShowSuccess = setMessage;
    return () => {
      globalShowSuccess = null;
    };
  }, []);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => setMessage(null), 4000);
    return () => clearTimeout(timer);
  }, [message]);

  const handleClose = () => setMessage(null);

  return message ? (
    <div style={{
      position: "fixed",
      top: 20,
      right: 20,
      background: "#2e7d32",
      color: "white",
      padding: "16px 24px",
      borderRadius: 8,
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      zIndex: 9999,
      fontWeight: "bold",
      minWidth: 240,
      maxWidth: 400,
      display: "flex",
      alignItems: "flex-start",
      gap: 12,
    }}>
      <span style={{ wordBreak: "break-word", flex: 1 }}>{message}</span>
      <button onClick={handleClose} style={{
        flexShrink: 0,
        alignSelf: "flex-start",
        background: "transparent",
        color: "white",
        border: "none",
        fontSize: 18,
        cursor: "pointer",
        lineHeight: 1,
        padding: 0,
      }}>×</button>
    </div>
  ) : null;
}

export function showGlobalErrorToast(msg) {
  if (globalShowError) {
    globalShowError(msg);
  } else {
    console.error(msg);
  }
}

export function showGlobalSuccessToast(msg) {
  if (globalShowSuccess) {
    globalShowSuccess(msg);
  }
}

export function GlobalToastContainer() {
  const errorToast = useGlobalErrorToast();
  const successToast = useGlobalSuccessToast();
  return <>{errorToast}{successToast}</>;
}
